import * as React from "react";

import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import { Button, Tabs } from "antd";
import { useState } from "react";
import { showError } from "../../../../../helpers/toast";
import { kmlToGeoJSON, readGeoJson, readKml, readZip } from "../FileUtils";
import { addAOIFeature, setDrawingAOIMode } from "../../store/slices/aoiSlice";
import { AOI_FEATURE_KEY } from "./consts";

export default function FormUpload(props: any)
{
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [shapeFile, setShapeFile] = React.useState<any>(null);
  const [geojsonFile, setGeojsonFile] = React.useState<any>(null);
  const [kmlFile, setKmlFile] = React.useState<any>(null);
  const [activeTab, setActiveTab] = useState<"geojson" | "kml" | "shape">(
    "geojson",
  );

  const onClose = () =>
  {
    props.toggleUpload();
  };

  const readFile = async () =>
  {
    switch (activeTab)
    {
      case "shape":
        await readShapeFile(shapeFile);
        break;
      case "geojson":
        await readGeojsonFile(geojsonFile);
        break;
      case "kml":
        await readKmlFile(kmlFile);
        break;
    }

    onClose(); // chạy sau khi dispatch xong
  };

  const readShapeFile = async (file: File) =>
  {
    try
    {
      let zipContent = await readZip(file);
      if (zipContent)
      {
        //@ts-ignore
        let geojson = await shp(zipContent);
        if (geojson && geojson.features)
        {
          //@ts-ignore
          let feature = geojson?.features.length ? geojson?.features[0] : null;
          if (feature)
          {
            feature.id = activeTab + "_" + new Date().getTime();
            // addGeojson2Map(feature);
          }
        }
      }
    } catch (ex: any)
    {
      showError(ex);
    }
  };
  const readGeojsonFile = async (file: File) =>
  {
    try
    {
      let geojson = await readGeoJson(file);

      const features = geojson?.geoJSON?.features || [];

      if (features.length > 0)
      {
        features.forEach((feature: any) =>
        {
          if (feature?.geometry)
          {
            dispatch(
              addAOIFeature({
                id: `${AOI_FEATURE_KEY}-${crypto.randomUUID()}`,
                geometry: feature.geometry,
              }),
            );

            dispatch(setDrawingAOIMode('UPLOAD_AOI'))
          }
        });
      }
    } catch (ex: any)
    {
      showError(ex);
    }
  };
  const readKmlFile = async (file: File) =>
  {
    try
    {
      let kmlContent = await readKml(file);
      if (kmlContent)
      {
        let geojson: any = kmlToGeoJSON(kmlContent);

        const features = geojson?.[0]?.features || [];

        if (features?.length > 0)
        {
          features.forEach((feature: any) =>
          {
            if (feature?.geometry)
            {
              dispatch(
                addAOIFeature({
                  id: `${AOI_FEATURE_KEY}-${crypto.randomUUID()}`,
                  geometry: feature.geometry,
                }),
              );

              dispatch(setDrawingAOIMode('UPLOAD_AOI'))
            }
          });
        }
      }
    } catch (ex: any)
    {
      showError(ex);
    }
  };

  const handleFile = (file: File) =>
  {
    const ext = file.name.split(".").pop()?.toLowerCase();

    if (ext === "kml")
    {
      setActiveTab("kml");
      setKmlFile(file);
      return;
    }

    if (ext === "geojson" || ext === "json")
    {
      setActiveTab("geojson");
      setGeojsonFile(file);
      return;
    }
  };

  function UploadAOI({ file, onChange }: any)
  {
    return (
      <div className="py-6 px-2">
        <div className="flex items-center gap-3">
          <input
            id="upload-file"
            type="file"
            accept=".geojson,.kml"
            className="hidden"
            onChange={(e) =>
            {
              if (e.target.files)
              {
                onChange(e.target.files[0]);
              }
            }}
          />

          <label
            htmlFor="upload-file"
            className="px-4 py-2 rounded-full bg-white/80 text-black cursor-pointer hover:bg-white"
          >
            Choose File
          </label>

          <span className="text-gray-300">
            {file ? file.name : "No file chosen"}
          </span>
        </div>

        {file && (
          <section className="py-4 !text-[var(--color-label-form)]">
            <h6 className="text-white text-sm after:content-[''] after:block after:w-full after:border-b after:border-dashed after:border-[#444] after:mt-1">
              {t("File details")}:
            </h6>
            <ul className="mt-2 gap-y-2 text-white">
              <li key={1}>
                {t("Name")}: {file.name}
              </li>
              <li key={2}>
                {t("Type")}: {file.type}
              </li>
              <li key={3}>
                {t("Size")}: {file.size} {t("bytes")}
              </li>
            </ul>
          </section>
        )}
      </div>
    );
  }

  const renderTabs = () =>
  {
    return (
      <>
        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key as any)}
          items={[
            {
              key: "geojson",
              label: "Geojson",
              children: <UploadAOI file={geojsonFile} onChange={handleFile} />,
            },
            {
              key: "kml",
              label: "Kml",
              children: <UploadAOI file={kmlFile} onChange={handleFile} />,
            },
          ]}
        />
      </>
    );
  };

  return (
    <div>
      {renderTabs()}

      <div className="flex gap-2 justify-end">
        <Button
          className="h-8 w-[100px] btn-outline"
          onClick={() =>
          {
            props?.toggleUpload();
          }}
        >
          {t("Cancel")}
        </Button>
        <Button
          className="h-8 w-[100px]  rounded btn-primary"
          onClick={() =>
          {
            readFile();
          }}
          disabled={!(geojsonFile || kmlFile)}
        >
          {t("Yes")}
        </Button>
      </div>
    </div>
  );
}
